import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { getCroppedImg } from "../Component/Profile/MyProfile/cropUtils";

// Action Types
export const FETCH_USER_PROFILE_LOADING = "FETCH_USER_PROFILE_LOADING";
export const FETCH_USER_PROFILE_SUCCESS = "FETCH_USER_PROFILE_SUCCESS";
export const FETCH_USER_PROFILE_ERROR = "FETCH_USER_PROFILE_ERROR";

export const UPDATE_USER_PROFILE_LOADING = "UPDATE_USER_PROFILE_LOADING";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_ERROR = "UPDATE_USER_PROFILE_ERROR";

export const UPLOAD_PROFILE_PHOTO_LOADING = "UPLOAD_PROFILE_PHOTO_LOADING";
export const UPLOAD_PROFILE_PHOTO_SUCCESS = "UPLOAD_PROFILE_PHOTO_SUCCESS";
export const UPLOAD_PROFILE_PHOTO_ERROR = "UPLOAD_PROFILE_PHOTO_ERROR";

// Fetch User Profile
export const FetchUserProfile = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  const decodedToken = jwtDecode(token);

  dispatch({ type: FETCH_USER_PROFILE_LOADING });
  try {
    const url = `${process.env.REACT_APP_API_URL}/user?userGuid=${decodedToken.userGuid}`;
    const response = await axios({
      method: "GET",
      url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: FETCH_USER_PROFILE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_USER_PROFILE_ERROR,
      payload: error.response?.data || error.message,
    });
  }
};

// Update User Profile
export const UpdateUserProfile = (formData, editData) => async (dispatch) => {
  dispatch({ type: UPDATE_USER_PROFILE_LOADING });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);

    const formDataToSend = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      passKey: "string",
      telephone: formData.phoneNumber,
      gender: "string",
      tenantId: editData.tenantId,
      tenantName: "string",
      title: "None",
      roleName: editData.roleId,
      note: editData.note,
      userRoles: [editData.roleId],
      userStatus: editData.status,
    };

    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/user/${decodedToken.userGuid}`,
      formDataToSend,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: UPDATE_USER_PROFILE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_USER_PROFILE_ERROR,
      payload: error.response?.data || error.message,
    });
  }
};

export const ResetProfileState = () => ({
  type: "RESET_PROFILE_STATE",
});

export const UploadProfilePhoto =
  (imagePreview, croppedArea, rotation) => async (dispatch) => {
    dispatch({ type: UPLOAD_PROFILE_PHOTO_LOADING });

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const decodedToken = jwtDecode(token);

      const croppedImage = await getCroppedImg(
        imagePreview,
        croppedArea,
        rotation
      );

      const formData = new FormData();
      formData.append("image", croppedImage, "cropped-image.jpeg");

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/image/upload/${decodedToken.userGuid}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
        dispatch({ type: UPLOAD_PROFILE_PHOTO_SUCCESS });
        dispatch(FetchUserProfile()); // optional: refetch updated profile
      } else {
        dispatch({
          type: UPLOAD_PROFILE_PHOTO_ERROR,
          payload: "Upload failed. Please try again.",
        });
      }
    } catch (error) {
      dispatch({
        type: UPLOAD_PROFILE_PHOTO_ERROR,
        payload: error.message || "Upload failed. Please try again.",
      });
    }
  };
